import { type BaseTicketComment } from "@mg/schemas/src/christo/catalyst";

export type SessionPinOverride = {
  commentId: string;
  relX: number;
  relY: number;
};

/**
 * Applies a session-only pin offset for the active comment only. Other
 * comments and inactive pins keep their server coordinates.
 */
export function applyActiveSessionPin(
  comments: BaseTicketComment[] | undefined,
  activeCommentId: string | null,
  override: SessionPinOverride | null,
): BaseTicketComment[] | undefined {
  if (!comments || !override || !activeCommentId) return comments;
  if (override.commentId !== activeCommentId) return comments;
  return comments.map((c) =>
    c._id === activeCommentId
      ? { ...c, rel_x: override.relX, rel_y: override.relY }
      : c,
  );
}
